import { render } from "./page_layout.vue?vue&type=template&id=9ebc1cce&scoped=true"
import script from "./page_layout.vue?vue&type=script&lang=js"
export * from "./page_layout.vue?vue&type=script&lang=js"

import "./page_layout.vue?vue&type=style&index=0&id=9ebc1cce&scoped=true&lang=css"

import exportComponent from "/Users/aaronlin/pushstack/webapp/togs-xlr8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ebc1cce"]])

export default __exports__